import { FC } from 'react';
import { Review } from '../../interfaces/types';
import { Divider, List, ListItem, Typography } from '@mui/material';
import ReviewListItem from './ReviewListItem';
import { useCustomThemeContext } from '../../providers/customThemeProvider';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useUserContext } from '../../providers/userProvider';
dayjs.extend(relativeTime);

interface ReviewListProps {
    reviews: Review[];
}

const ReviewList: FC<ReviewListProps> = ({ reviews }) => {
    const { theme } = useCustomThemeContext();
    const { getUserById } = useUserContext();
    return (
        <List
            sx={{
                width: '100%',
                position: 'relative',
                overflow: 'auto',
                maxHeight: '1000px',
                scrollbarColor: theme.palette.primary.main + ' transparent',
            }}

        >
    {reviews.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).map((review) => {
        const usernameReviewer = getUserById(review.createdBy)?.username || 'Unknown User';
        return (
            <ListItem key={review.id} sx={{ display: 'flex', flexDirection: 'column', px: 2 }}>
                <Divider component="div" role="presentation" sx={{ marginBottom: 2, width: '100%' }}>
                    <Typography variant='body2'>Review by {usernameReviewer}</Typography>
                    <Typography variant='body2'>{dayjs(review.createdAt).fromNow()}</Typography>
                </Divider>
                <ReviewListItem review={review} />
            </ListItem>
        );
    })}
        </List>
    );
};

export default ReviewList;